import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as actions from "../../store/actions";
import { push } from "connected-react-router";
import './Menu.scss';
import { Link } from 'react-router-dom';
import * as userService from "../../services/userService"


class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isShowUser: false,
            user: {
                email: "",
                name: "",
                phoneNumber: "",
                isSA: false
            }
        }
    }
    componentDidMount() {
        this.getCurrentUser();
    }
    getCurrentUser = async () => {
        let res = await userService.getCurrentInfo();
        if (res == 0) {
            return;
        }
        else if (res.isSuccess) {
            let copyState = { ...this.state.user };
            copyState = res.data;
            this.setState({
                user: copyState
            })
        }
        else {
            return;
        }
    }
    showInfoUser = () => {
        this.setState({
            isShowUser: !this.state.isShowUser
        })
    }
    render() {
        const { processLogout } = this.props;

        return (
            <div className="app-menu navbar-menu">
                <div className="navbar-brand-box">
                    <a href="#" className="logo logo-dark">
                        <span className="logo-sm">
                            <img src="../../assets/images/logo-sm.png" alt="" height="22" />
                        </span>
                        <span className="logo-lg">
                            <img src="../../assets/images/logo-dark.png" alt="" height="17" />
                        </span>
                    </a>
                    <a href="#" className="logo logo-light">
                        <span className="logo-sm">
                            <img src="../../assets/images/logo-sm.png" alt="" height="22" />
                        </span>
                        <span className="logo-lg">
                            <img src="../../assets/images/logo-dark.png" alt="" height="17" />
                        </span>
                    </a>
                    <button type="button" className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        id="vertical-hover">
                        <i className="ri-record-circle-line"></i>
                    </button>
                </div>

                <div id="scrollbar">
                    <div className="container-fluid">

                        <div id="two-column-menu">
                        </div>
                        <ul className="navbar-nav" id="navbar-nav">
                            <li className="menu-title"><span data-key="t-menu">ADMIN QUẢN LÝ</span></li>
                            <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/client-manager">
                                    <i className="ri-dashboard-2-line"></i> <span data-key="t-dashboards">Quản lý khách hàng</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/payment-history">
                                    <i className="ri-dashboard-2-line"></i> <span data-key="t-dashboards">Lịch sử nạp</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/dowload-history">
                                    <i className="ri-dashboard-2-line"></i> <span data-key="t-dashboards">Lịch sử tải</span>
                                </a>
                            </li>
                            {this.state.user.isSA && <li className="menu-title"><span data-key="t-menu">SEUPER ADMIN</span></li>}
                            {this.state.user.isSA && <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/user-manager">
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Quản lý tài khoản</span>
                                </a>
                            </li>}
                            {this.state.user.isSA && <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/supplier-manager">
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Quản lý nguồn</span>
                                </a>
                            </li>}
                            {this.state.user.isSA && <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/new-manager">
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Quản lý tin tức</span>
                                </a>
                            </li>}
                            {this.state.user.isSA && <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/balance-manager">
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Xem số dư</span>
                                </a>
                            </li>}
                            {this.state.user.isSA && <li className="nav-item">
                                <a className="nav-link menu-link" href="/system/noti-manager">
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Quản lý thông báo</span>
                                </a>
                            </li>}
                            {/* <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarApps">
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Shutter Video</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarLayouts">
                                    <i className="ri-layout-3-line"></i> <span data-key="t-layouts">Shutter</span>
                                </a>
                            </li>

                            <li className="menu-title"><i className="ri-more-fill"></i> <span data-key="t-pages">TÀI KHOẢN</span></li>

                            <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarAuth">
                                    <i className="ri-pages-line"></i> <span
                                        data-key="t-authentication">Tin tức</span>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarPages">
                                    <i className="ri-account-circle-line"></i> <span data-key="t-pages">Hỗ trợ</span>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarLanding">
                                    <i className="ri-rocket-line"></i> <span data-key="t-landing">Nạp xu</span>
                                </a>
                            </li>

                            <li className="nav-item">
                                <a className="nav-link menu-link" href="#sidebarUI">
                                    <i className="mdi mdi-lifebuoy"></i> <span data-key="t-base-ui">Liên hệ</span>
                                </a>
                            </li> */}
                        </ul>
                    </div>
                </div>

                <div className="sidebar-background"></div>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        isLoggedIn: state.user.isLoggedIn
    };
};

const mapDispatchToProps = dispatch => {
    return {
        navigate: (path) => dispatch(push(path)),
        processLogout: () => dispatch(actions.processLogout()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
